import './module.js';

import './model/uniswap-access.js';

import './model/interface/v2/factory-contract-interface.js';
import './model/interface/v2/pair-contract-interface.js';
import './model/interface/v2/router02-contract-interface.js';

//import './model/interface/v1/exchange-contract-interface.js';
